import React, { createContext, useContext, useEffect, useState } from "react";
import { apiMe, apiLogin, apiRegister, getToken, setToken, clearToken } from "./api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const boot = async () => {
      if (window.location.hash?.includes("session_id=")) {
        setReady(true);
        return;
      }
      if (!getToken()) {
        setUser(false);
        setReady(true);
        return;
      }
      try {
        const u = await apiMe();
        setUser(u);
      } catch {
        clearToken();
        setUser(false);
      } finally {
        setReady(true);
      }
    };
    boot();
  }, []);

  const login = async (email, password) => {
    clearToken();
    const data = await apiLogin({ email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithToken = (token, u) => {
    setToken(token);
    setUser(u);
  };

  const register = async (payload) => {
    const data = await apiRegister(payload);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, loginWithToken, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};
